// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"ai-search","clipPath":"url(#clip0_365_141)"},"nodeName":"g","children":[{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M16.75 2.5L17.2697 3.73028L18.5 4.25L17.2697 4.76972L16.75 6L16.2303 4.76972L15 4.25L16.2303 3.73028L16.75 2.5Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M15.8027 15.8037L21.106 21.107M15.8027 15.8037C12.8738 18.7327 8.12563 18.7323 5.1967 15.8033C2.26777 12.8744 2.26777 8.12565 5.1967 5.19672C6.53393 3.85949 8.25048 3.13278 10 3.0166M15.8027 15.8037C17.14 14.4664 17.8669 12.7497 17.9831 11","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-ai-search')
export default class AiSearchIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai-search',
    }
  }
}
